import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BonusEvent } from '~models/bonus.model';
import { CrudService } from '~services/crud.service';
import { BonusApiService } from '~services/api/bonus.api.service';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserApiService } from '~services/api/user.api.service';
import { UserService } from '~services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmActionDialogComponent } from '../../ui-components/confirm-action-dialog/confirm-action-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'sa-bonus-event-active',
  templateUrl: './bonus-event-active.component.html',
  styleUrls: ['./bonus-event-active.component.scss'],
})
export class BonusEventActiveComponent implements OnInit {
  constructor(
    private crud: CrudService,
    private bonusApiService: BonusApiService,
    private userApiService: UserApiService,
    public userService: UserService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar,
    public router: Router,
  ) {
    this.canCrudUsers$ = this.userApiService.canCreateUsers$.pipe(
      filter((result) => result?.initialized),
      map((res) => res.canCrud),
    );
    this.canCrudUsers$.subscribe((result) => {
      this.showAddButton = this.userService.hasPermission('can_add_bonus_event') && result;
      if (this.showAddButton) {
        this.displayedColumns = [...this.displayedColumns, 'update', 'delete'];
      }
    });
  }
  displayedColumns: string[] = [
    'name',
    'pricingType',
    'pricingValue',
    'startAt',
    'endAt',
    'loadCount',
    'totalBonusAmount',
    'quota',
    'createdAt',
  ];
  dataSource: MatTableDataSource<BonusEvent> = new MatTableDataSource();
  public canCrudUsers$: Observable<boolean>;
  public showAddButton = false;

  ngOnInit(): void {
    this.crud.httpClientReady.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.getBonusEvents();
    });
  }

  getBonusEvents() {
    this.bonusApiService.getBonusEvents().subscribe((items) => {
      this.dataSource = new MatTableDataSource(items);
    });
  }

  async deleteBonusEvent(row) {
    let keepGoing = true;
    const confirmDialogRef = this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        cancelButtonText: 'Cancel',
        desc: 'Are you sure you want to cancel this bonus event permanently?',
        submitButtonText: 'Confirm',
        title: `Delete ${row.name}`,
      },
    });

    keepGoing = await confirmDialogRef.afterClosed().toPromise();
    if (!keepGoing) {
      return;
    }

    this.bonusApiService.deleteBonusEvent(row.id).subscribe(
      () => {
        this.snackBar.open('Bonus event successfully removed', null, {
          duration: 2000,
        });
        this.getBonusEvents();
      },
      (error) => {
        this.snackBar.open(error.error ? error.error.Message : error.Message, null, {
          duration: 5000,
          panelClass: ['snackbar-error'],
        });
      },
    );
  }

  sortTable(event) {
    switch (event.active) {
      case 'id':
        const sortedId = this.dataSource.data.sort((a, b) => {
          return a.id.toString().localeCompare(b.id.toString());
        });
        if (event.direction === 'desc') {
          sortedId.reverse();
        }
        this.dataSource.data = sortedId;
        break;
      case 'name':
        const sortedName = this.dataSource.data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        if (event.direction === 'desc') {
          sortedName.reverse();
        }
        this.dataSource.data = sortedName;
        break;
      case 'quota':
        const sortedQuota = this.dataSource.data.sort((a, b) => {
          return a.quota.toString().localeCompare(b.quota.toString());
        });
        if (event.direction === 'desc') {
          sortedQuota.reverse();
        }
        this.dataSource.data = sortedQuota;
        break;
      case 'startAt':
        const sortedStartAt = this.dataSource.data.sort((a, b) => {
          return a.startAt.localeCompare(b.startAt);
        });
        if (event.direction === 'desc') {
          sortedStartAt.reverse();
        }
        this.dataSource.data = sortedStartAt;
        break;
      case 'endAt':
        const sortedEndAt = this.dataSource.data.sort((a, b) => {
          return a.endAt.localeCompare(b.endAt);
        });
        if (event.direction === 'desc') {
          sortedEndAt.reverse();
        }
        this.dataSource.data = sortedEndAt;
        break;
      case 'createdAt':
        const sortedCreatedAt = this.dataSource.data.sort((a, b) => {
          return a.createdAt.localeCompare(b.createdAt);
        });
        if (event.direction === 'desc') {
          sortedCreatedAt.reverse();
        }
        this.dataSource.data = sortedCreatedAt;
        break;
    }
  }

  onRowClicked(row: any): void {
    if (this.showAddButton) {
      this.router.navigate(['/bonus-event', 'form', 'view', row.id]);
    }
  }
}
